(() => {
  const root = document.querySelector('.ctt-land');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const triggers = [...root.querySelectorAll('.zoom')];
  const image = dialog.querySelector('.lightbox-image');
  let current = 0;
  let touchStart = null;
  function show(index) {
    current = (index + triggers.length) % triggers.length;
    const source = triggers[current].querySelector('img');
    image.src = source.dataset.full;
    image.alt = source.alt;
    image.width = source.width;
    image.height = source.height;
    dialog.querySelector('#photo-position').textContent = `${current + 1} / ${triggers.length}`;
    dialog.querySelector('.lightbox-caption').textContent = triggers[current].closest('figure').querySelector('figcaption').textContent;
  }
  triggers.forEach((button, index) => button.addEventListener('click', () => {
    show(index);
    dialog.showModal();
  }));
  dialog.querySelector('[aria-label="Close enlarged image"]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[aria-label="Previous image"]').addEventListener('click', () => show(current - 1));
  dialog.querySelector('[aria-label="Next image"]').addEventListener('click', () => show(current + 1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  image.addEventListener('touchstart', event => {
    touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  image.addEventListener('touchend', event => {
    if (!touchStart || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
})();
